import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { AdUnitTableSchema } from 'features/inventory/ad-unit/forms/AdUnitTableForm/schema'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { toDTO } from './api/mapper'
import { UPDATE_AD_UNITS } from './api/mutation'

import type { UpdateAdUnitsMutation, UpdateAdUnitsMutationVariables } from 'gql/graphql'

type UseSaveAdUnitProducts = {
  loading: boolean
  update: (data: AdUnitTableSchema) => void
}

export const useSaveAdUnitProducts = (): UseSaveAdUnitProducts => {
  const { t } = useTranslation('features/adUnit')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending, mutateAsync } = useMutation<
    { input: UpdateAdUnitsMutationVariables['input'] },
    UpdateAdUnitsMutation
  >({
    mutation: UPDATE_AD_UNITS,
    onCompleted: async (data: UpdateAdUnitsMutation) => {
      const errors = data.updateAdUnits?.errors

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('list.save.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('list.save.success'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getAdUnitsForTable'],
  })

  const update = (data: AdUnitTableSchema): void => {
    const input = toDTO(data)

    if (input.adUnitsAttributes?.length === 0) {
      return
    }

    void mutateAsync({
      input,
    })
  }

  return {
    loading: isPending,
    update,
  }
}
